<template>
    <div>
        <batch-list :items="batches"></batch-list>
        <div class="text-center">
            <v-pagination
                    v-model="currentPage"
                    :length="getTotalBatchPages"
            ></v-pagination>
        </div>
        <div>
            <v-btn class="mt-2"
                   color="success"
                   :disabled="progress('createBatch')"
                   :loading="progress('createBatch')"
                   @click="handleCreateBatchButtonClick">Create run
            </v-btn>
        </div>
    </div>

</template>

<script>
    import BatchList from './BatchList'
    import {mapActions, mapGetters} from 'vuex'

    export default {
        name: "BatchContainer",
        components: {
            BatchList
        },
        computed: {
            ...mapGetters('batches', {
                progress: 'progress',
                batches: 'batches',
                getTotalBatchPages: 'getTotalBatchPages',
                getBatchCurrentPage: 'getBatchCurrentPage'
            }),
            currentPage: {
                get() {
                    return this.getBatchCurrentPage
                },
                set(page) {
                    this.setBatchCurrentPage(page)
                }
            }
        },
        async created() {
            await this.getBatches()
            await this.getCasesWithMissingSamples()
        },
        methods: {
            ...mapActions('batches', {
                createBatch: 'createBatch',
                getBatches: 'getBatches',
                setBatchCurrentPage: 'setBatchCurrentPage',
                getCasesWithMissingSamples: 'getCasesWithMissingSamples'
            }),
            handleCreateBatchButtonClick() {
                this.createBatch({
                    size: 96
                })
            }
        }

    }
</script>

<style scoped>

</style>